import API from 'API';
import {ApplicationStatusResponse} from 'API/Info/info.Models'

export const getApplicationStatus = async () => {
  try {
    const response = await API.Info.Connectors.getApplicationStatus()
    return response.data
  } catch (e) {
    return null
  }
}

export const checkApplicationStatus = (applicationStatusData?: ApplicationStatusResponse | null) =>
  applicationStatusData?.status === API.Info.Models.STATUS.MAINTENANCE



// WEBPACK FOOTER //
// ./src/Modules/TechnicalBreak/Service/TechnicalBreak.Services.ts